export default {
  setList(state, list) {
    state.list = [...state.list, ...list];
  },
  setPageInfo(state, pageInfo) {
    state.pageInfo = pageInfo;
  },
  setPage(state, page = 1) {
    state.condition.page = page;
  },
  purge(state, _) {
    state.pageInfo = { page: 1, totalPage: 2 };
    state.list = [];
    state.condition.page = 1;
  },
  setAction(state, action) {
    state.condition.action = action;
  },
  setUserNo(state, userNo) {
    state.condition.userNo = userNo;
  },

  setTotalPoint(state, response) {
    state.totalPoint = response;
  }
};
